import { render } from "./CompanyBlock.vue?vue&type=template&id=e68e230c&ts=true"
import script from "./CompanyBlock.vue?vue&type=script&lang=ts"
export * from "./CompanyBlock.vue?vue&type=script&lang=ts"

import "./CompanyBlock.vue?vue&type=style&index=0&id=e68e230c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__